import { ChevronRightThin } from "assets/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  height: fit-content;
  align-self: center;
  margin-right: ${({ theme }) => theme.margin.m16};
  transition: all 0.2s linear;

  &:hover {
    span {
      transition: all 0.2s linear;
      color: ${({ theme }) => theme.colors.colorsNew.gray["400"]};
    }
    svg {
      transition: all 0.2s linear;
      path {
        transition: all 0.2s linear;
        stroke: ${({ theme }) => theme.colors.colorsNew.gray["400"]};
      }
    }
  }
`;

export const StyledBackIcon = styled(ChevronRightThin)`
  transform: rotate(180deg);
`;

export const ButtonText = styled.span`
  text-transform: capitalize;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.size.body2};
  line-height: ${({ theme }) => theme.lineHeight.lh140};
  margin-left: ${({ theme }) => theme.margin.m8};
  color: ${({ theme }) => theme.colors.colorsNew.gray["500_main"]};
`;
